"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipPopper = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TooltipPopperMixin = require("../../mixins/components/TooltipPopperMixin");
var _Popper = require("../Popper/Popper");
/**
 * A `Popper` configured specifically for tooltips. Ensures that tooltips are visible on focus or
 * hover by default.
 *
 * @extends Popper
 * @related ['Tooltip', 'Trigger']
 * @since 7.0.0
 */
var TooltipPopper = /*#__PURE__*/(0, _styledComponents.default)(_Popper.Popper).withConfig({
  displayName: "TooltipPopper",
  componentId: "c11n-8-109-1__sc-1v2hxhd-0"
})(["", ""], _TooltipPopperMixin.TooltipPopperMixin);
exports.TooltipPopper = TooltipPopper;
TooltipPopper.displayName = 'TooltipPopper';
TooltipPopper.propTypes = {
  /**
   * Trigger has aria-haspopup defined by default, however aria does not consider a tooltip to be
   * a popup in this case. Need to set this to false.
   *
   * @ignore
   */
  'aria-haspopup': _propTypes.default.string,
  /**
   * The `Trigger` `mouseEnterDelay` prop.
   */
  'mouseEnterDelay': _propTypes.default.number,
  /**
   * The `Trigger` `mouseLeaveDelay` prop.
   */
  'mouseLeaveDelay': _propTypes.default.number,
  /**
   * The `Trigger` `openWith` prop.
   */
  'openWith': _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * The `Trigger` `closeWith` prop.
   */
  'closeWith': _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * The `Trigger` `generateDescribedBy` prop.
   */
  'generateDescribedBy': _propTypes.default.bool
};
TooltipPopper.defaultProps = {
  'aria-haspopup': 'false',
  'mouseEnterDelay': 500,
  'mouseLeaveDelay': 500,
  'openWith': ['click', 'focus', 'mouseEnter'],
  'closeWith': ['click', 'blur', 'mouseLeave'],
  'generateDescribedBy': true,
  'shouldFocusTriggered': false,
  'shouldCloseOnViewportLeave': true
};

/** @component */